import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import {
	answerTypeMap,
	questionTypeToBackendType,
} from "../../../constants/answerType";
import uri from "../../../constants/uri";
import deleteAnswer from "./deleteAnswer";
import checkQuestionFiles from "./checkQuestionFiles";
import createAnswer from "./createAnswer";
import checkAnswers from "./checkAnswers";
import editAnswer from "./editAnswer";

const editQuestion = async (
	newQuestion,
	savedQuestion,
	questionId,
	votingId
) => {
	try {
		await client.put(
			`${uri}/question`,
			{
				Id: questionId,
				VotingId: votingId,
				TypeId: questionTypeToBackendType[newQuestion.answerType],
				OrderNum: questionId,
				Text: newQuestion.title,
				Obligatory: newQuestion.obligatory,
			},
			{
				headers: authHeader(),
			}
		);
		const newQuestionIsText =
			questionTypeToBackendType[newQuestion.answerType] === 3;
		const savedQuestionIsText = savedQuestion.type.id === 3;

		if (!newQuestionIsText || !savedQuestionIsText) {
			const changedToText = newQuestionIsText && !savedQuestionIsText;
			const changedFromText = !newQuestionIsText && savedQuestionIsText;

			if (changedToText || changedFromText) {
				await Promise.all(
					savedQuestion.answers.map((savedAnswer) => {
						deleteAnswer(savedAnswer.id);
					})
				);
			}

			if (changedToText) {
				await createAnswer(
					{ text: "Ваш ответ" },
					savedQuestion.id,
					1,
					"writing"
				);
			}

			if (changedFromText) {
				await checkAnswers([], newQuestion.answers, questionId);
			}

			if (!newQuestionIsText && !savedQuestionIsText) {
				await checkAnswers(
					savedQuestion.answers.filter((answer) => {
						return answer.type.id !== answerTypeMap.writing;
					}),
					newQuestion.answers,
					questionId
				);
			}
		}

		const savedOtherOption =
			!savedQuestionIsText &&
			savedQuestion.answers.find((answer) => {
				return answer.type.id === answerTypeMap.writing;
			});

		if (savedOtherOption && !newQuestion.haveOtherOption) {
			await deleteAnswer(savedOtherOption.id);
		}
		if (newQuestion.haveOtherOption) {
			const maxOrderNum =
				Number(
					Object.keys(newQuestion.answers || {}).reduce((acc, answerKey) => {
						return Math.max(+answerKey, +acc);
					}, 0)
				) || 0;

			if (!savedOtherOption && newQuestion.haveOtherOption) {
				await createAnswer(
					{
						text: "Другое",
					},
					questionId,
					maxOrderNum + 1,
					"writing"
				);
			}
			if (savedOtherOption && newQuestion.haveOtherOption) {
				await editAnswer(
					{
						text: "Другое",
					},
					savedOtherOption,
					questionId,
					maxOrderNum + 1,
					"writing"
				);
			}
		}
		if (newQuestion.files || savedQuestion.files) {
			await checkQuestionFiles(savedQuestion, newQuestion);
		}
	} catch (e) {
		console.error(e);
		message.error("Не получилось отредактировать вопрос, попробуйте позже");
	}
};

export default editQuestion;
